<template>
  <div class="basic-stats">
    <div class="basic-stats__flex">
      <div class="basic-stats__wrapper">
        <div class="basic-stats__wrapper-grid basic-stats__wrapper-grid--triple">
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.allSessions') }}</div>
            <div class="basic-stats__cell-value">{{ stats.sessions.count }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.summarySessionTime') }}</div>
            <div
              class="basic-stats__cell-value basic-stats__cell-value--small"
            >{{ secToDuration(stats.sessions.total_duration) }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.messagesPerSession') }}</div>
            <div class="basic-stats__cell-value">{{ Math.round(stats.sessions.avg_messages) }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.avgSessionTime') }}</div>
            <div
              class="basic-stats__cell-value"
            >{{ secToDuration(Math.round(stats.sessions.avg_duration)) }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.minSessionTime') }}</div>
            <div class="basic-stats__cell-value">{{ secToDuration(stats.sessions.min_duration) }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.maxSessionTime') }}</div>
            <div class="basic-stats__cell-value">{{ secToDuration(stats.sessions.max_duration) }}</div>
          </div>
        </div>
      </div>
      <div class="basic-stats__divider"></div>
      <div class="basic-stats__wrapper">
        <div class="basic-stats__wrapper-grid basic-stats__wrapper-grid--triple">
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.sent') }}</div>
            <div
              class="basic-stats__cell-value basic-stats__cell-value--small"
            >{{ this.stats.basic.sent || 0 }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.received') }}</div>
            <div class="basic-stats__cell-value">{{ this.stats.basic.received || 0 }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.total') }}</div>
            <div
              class="basic-stats__cell-value"
            >{{ parseInt(this.stats.basic.sent || 0) + parseInt(this.stats.basic.received || 0) }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.ratio') }}</div>
            <div
              class="basic-stats__cell-value"
            >{{ (parseInt(this.stats.basic.sent || 0) / parseInt(this.stats.basic.received || 1)).toFixed(2) }}</div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.genders') }}</div>
            <div class="basic-stats__cell-value" v-if="stats.basic.genders">
              {{ $t('view.dashboard.basic.male') }}: {{ Math.round(parseInt(this.stats.basic.genders.male || 0) / (parseInt(this.stats.basic.genders.male || 1) + parseInt(this.stats.basic.genders.female || 0)) * 100) + '%' }}
              <br>
              {{ $t('view.dashboard.basic.female') }}: {{ Math.round(parseInt(this.stats.basic.genders.female || 0) / (parseInt(this.stats.basic.genders.male || 1) + parseInt(this.stats.basic.genders.female || 0)) * 100) + '%' }}
            </div>
          </div>
          <div class="basic-stats__cell">
            <div class="basic-stats__cell-title">{{ $t('view.dashboard.basic.daysOnline') }}</div>
            <div
              class="basic-stats__cell-value"
            >{{ days(+new Date() - this.stats.basic.first_start) }} days</div>
          </div>
        </div>
      </div>
      <div class="basic-stats__divider"></div>
      <div class="basic-stats__wrapper">
        <div class="basic-stats__title">{{ $t('view.dashboard.basic.blocksEntries') }}</div>
        <div class="basic-stats__list">
          <div class="basic-stats__list-pos" v-for="(block, i) in stats.blocksEntries" :key="i">
            <div>{{ block.name }}</div>
            <div>{{ block.entries }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="basic-stats__controls">
      <sw-button
        class="basic-stats__control"
        v-model="parameters.rangeMode"
        :label="$t('component.chart.rangeMode')"
      ></sw-button>
      <div v-if="!parameters.rangeMode">
        <min-sel v-model="parameters.days" @input="daysChange">
          <option :value="14">14 {{ $t('component.chart.days') }}</option>
          <option :value="31">31 {{ $t('component.chart.days') }}</option>
          <option :value="90">90 {{ $t('component.chart.days') }}</option>
          <option :value="180">180 {{ $t('component.chart.days') }}</option>
          <option :value="365">365 {{ $t('component.chart.days') }}</option>
          <option :value="0">{{ $t('component.chart.lifetime') }}</option>
        </min-sel>
      </div>
      <div class="basic-stats__range" v-else>
        <in
          type="date"
          @input="rangeInput"
          class="basic-stats__control"
          v-model="parameters.rangeStart"
          :label="$t('component.chart.rangeStart')"
        ></in>
        <in
          type="date"
          @input="rangeInput"
          class="basic-stats__control"
          v-model="parameters.rangeStop"
          :label="$t('component.chart.rangeStop')"
        ></in>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      parameters: {
        rangeStart: null,
        rangeStop: null,
        rangeMode: false,
        days: 90,
      },
      stats: {
        sessions: {},
        basic: {},
        blocksEntries: {}
      }
    }
  },

  methods: {
    secToDuration(sec) {
      let days, hours, minutes, seconds;
      seconds = Math.floor(parseFloat(sec) * 1000 / 1000);
      minutes = Math.floor(seconds / 60);
      seconds = seconds % 60;
      hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      days = Math.floor(hours / 24);
      hours = hours % 24;

      let str = `${!isNaN(seconds) ? seconds : 0}s`
      if (minutes) str = `${!isNaN(minutes) ? minutes : 0}m ` + str
      if (hours) str = `${!isNaN(hours) ? hours : 0}h ` + str
      if (days) str = `${!isNaN(days) ? days : 0}d ` + str
      return str
    },

    days(ms) {
      const n = Math.floor(ms / (1000 * 60 * 60 * 24))
      return !isNaN(n) ? n : 0
    },

    async daysChange(v) {
      try {
        const dataReq = await axios.get('/api/stats/sessions?days=' + v)
        this.stats.sessions = dataReq.data.sessionsData
        const basicDataReq = await axios.get('/api/stats/basic?days=' + v)
        this.stats.basic = basicDataReq.data.basic
        const blocksDataReq = await axios.get('/api/stats/blocks-entries?days=' + v)
        this.stats.blocksEntries = blocksDataReq.data.rows
        this.stats.blocksEntries.sort((a, b) => (parseInt(a.entries) > parseInt(b.entries)) ? -1 : ((parseInt(b.entries) > parseInt(a.entries)) ? 1 : 0))
      } catch (e) {
        console.error(e)
      }
    },

    async rangeInput() {
      try {
        const start = this.parameters.rangeStart
        const stop = this.parameters.rangeStop
        if (!start || !stop) return

        const dataReq = await axios.get(`/api/stats/sessions-range?start=${start}&stop=${stop}`)
        this.stats.sessions = dataReq.data.sessionsData
        const basicDataReq = await axios.get(`/api/stats/basic-range?start=${start}&stop=${stop}`)
        this.stats.basic = basicDataReq.data.basic
        const blocksDataReq = await axios.get(`/api/stats/blocks-entries-range?start=${start}&stop=${stop}`)
        this.stats.blocksEntries = blocksDataReq.data.rows
        this.stats.blocksEntries.sort((a, b) => (parseInt(a.entries) > parseInt(b.entries)) ? -1 : ((parseInt(b.entries) > parseInt(a.entries)) ? 1 : 0))
      } catch (e) {
        console.error(e)
      }
    }
  },

  async created() {
    try {
      const dataReq = await axios.get('/api/stats/sessions?days=90')
      this.stats.sessions = dataReq.data.sessionsData
      const basicDataReq = await axios.get('/api/stats/basic?days=90')
      this.stats.basic = basicDataReq.data.basic

      const blocksDataReq = await axios.get('/api/stats/blocks-entries?days=90')
      this.stats.blocksEntries = blocksDataReq.data.rows
      this.stats.blocksEntries.sort((a, b) => (parseInt(a.entries) > parseInt(b.entries)) ? -1 : ((parseInt(b.entries) > parseInt(a.entries)) ? 1 : 0))
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-stats {
  @include flowElementShadow();
  padding: 20px 20px;
  background-color: white;
  border-radius: 4px;
  margin-top: 11px;

  &__flex {
    @include alignedFlex(space-between);
    width: 100%;
    height: 230px;
  }

  &__wrapper {
    width: 32%;
    height: 100%;
  }

  &__wrapper-grid {
    display: grid;
    grid-template-rows: 90px 90px;
    grid-row-gap: 20px;
    width: 100%;
    height: 100%;
    margin: 0 auto;

    &--triple {
      grid-template-columns: 33.33% 33.33% 33.33%;
    }
  }

  &__divider {
    height: 220px;
    width: 1px;
    background-color: $borderGrey;
    margin: 0 18px;
  }

  &__cell-title {
    top: 0;
    text-align: left;
    width: 100%;
    font-weight: 700;
    height: 50%;
  }

  &__cell-value {
    font-size: 1.2em;
    font-family: "Work Sans";
    padding-left: 5px;
  }

  &__controls {
    @include alignedFlex(flex-start);
    @include standarizeStatControls();
  }

  &__control {
    margin-right: 20px;
  }

  &__range {
    @include alignedFlex(flex-start);
  }

  &__title {
    top: 0;
    font-weight: 700;
  }

  &__list {
    overflow: auto;
    height: 95%;
    width: 85%;
    margin: 10px auto 0 auto;
  }

  &__list-pos {
    @include alignedFlex(space-between);
    padding: 2px 5px;
  }
}
</style>
